export default __webpack_public_path__ + "static/media/BussolaInvestidorLogo.4e86dda8.svg";